import React, { useState, useEffect, useCallback } from "react";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from "../common/common";
import moment from "moment";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import Snackbar from "../snackbar";
import UploadButton from "./UploadButton";
import UploadStatus from "./UploadStatus";
import _ from "lodash";
import ImageCropper from "./ImageCropper";

import { Create, Button,useTranslate} from "react-admin";
import { useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";

const ProductImagesCreate = (props) => {
  // props.location.query.order_number
  const translate = useTranslate();
  const navigate = useNavigate();

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [onSaveDisabled, setOnSaveDisabled] = useState(false);

  const [formSettings, setFormSettings] = useState("");
  // console.log('propssss=>', props.location.query.order_number);

  const [imageToCrop, setImageToCrop] = useState(undefined);
  const [croppedImage, setCroppedImage] = useState(undefined);
  const [bannerStatus, setBannerStatus] = useState(true);
  const [productName, setProductName] = useState("");
  const [productNameError, setProductNameError] = useState(true);
  // const [productDescription, setProductDescription] = useState("");
  // const [productDescriptionError, setProductDescriptionError] = useState(true);
  const [imageFile, setImageFile] = useState("");
  const [fileDimension, setFileDimension] = useState({
    height: 0,
    width: 0,
  });
  const [fileError, setFileError] = useState(false);
  const [isImageSelected, setIsImageSelected] = useState(false);

  const [productImagesArray, setProductImagesArray] = useState(
    Array(3).fill(0)
  );

  console.log("slow dancing in the dark", productImagesArray);

  /**
   * first product image variables
   */
  // const [imageToCropP1, setImageToCropP1] = useState(undefined);
  // const [croppedImageP1, setCroppedImageP1] = useState(undefined);
  // const [imageFileP1, setImageFileP1] = useState("");
  // const [fileDimensionP1, setFileDimensionP1] = useState({
  //   height: 0,
  //   width: 0,
  // });
  // const [fileErrorP1, setFileErrorP1] = useState(false);
  // const [isImageSelectedP1, setIsImageSelectedP1] = useState(false);

  /**
   * second product image variables
   */
  // const [imageToCropP2, setImageToCropP2] = useState(undefined);
  // const [croppedImageP2, setCroppedImageP2] = useState(undefined);
  // const [imageFileP2, setImageFileP2] = useState("");
  // const [fileDimensionP2, setFileDimensionP2] = useState({
  //   height: 0,
  //   width: 0,
  // });
  // const [fileErrorP2, setFileErrorP2] = useState(false);
  // const [isImageSelectedP2, setIsImageSelectedP2] = useState(false);

  /**
   * third product image variables
   */
  // const [imageToCropP3, setImageToCropP3] = useState(undefined);
  // const [croppedImageP3, setCroppedImageP3] = useState(undefined);
  // const [imageFileP3, setImageFileP3] = useState("");
  // const [fileDimensionP3, setFileDimensionP3] = useState({
  //   height: 0,
  //   width: 0,
  // });
  // const [fileErrorP3, setFileErrorP3] = useState(false);
  // const [isImageSelectedP3, setIsImageSelectedP3] = useState(false);

  const sumbitForm = () => {
    // const splitBusinessId = business[0].id;
    setOnSaveDisabled(true);

    const stateData = localStorage.getItem("__state");
    const userData = stateData ? JSON.parse(stateData) : false;

    const formData = new FormData();
    formData.append("image_data", imageFile);
    formData.append("name", productName);
    // formData.append("material_description", productDescription);
    // Array.from(productImagesArray).forEach((image, index) => {
    //   formData.append("product_images[" + index + "]", image);
    // });
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "POST";

    for (var key of formData.entries()) {
      console.log(key[0] + ", " + key[1]);
    }
    options.body = formData;
    fetch(`${apiUrl}/clickit_products`, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: userData._token,
        // "Content-Type": "multipart/form-data",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        setOnSaveDisabled(false);
        setShowSnackbar(true);
        setTimeout(() => {
          navigate(-1);
        }, 1000);
      })
      .catch((error) => {
        console.log("error==>", error);
      });
  };

  const changeProductName = (event) => {
    let positionObject = event.target.value;
    if (
      event.target.value === "" ||
      event.target.value === undefined ||
      event.target.value === null ||
      !event.target.value.trim().length
    ) {
      setProductNameError(true);
    } else {
      setProductNameError(false);
    }
    setProductName(positionObject);
  };

  // const changeProductDescription = (event) => {
  //   let positionObject = event.target.value;
  //   if (
  //     event.target.value === "" ||
  //     event.target.value === undefined ||
  //     event.target.value === null ||
  //     !event.target.value.trim().length
  //   ) {
  //     setProductDescriptionError(true);
  //   } else {
  //     setProductDescriptionError(false);
  //   }
  //   setProductDescription(positionObject);
  // };

  async function dataUrlToFile(dataUrl, fileName) {
    var arr = dataUrl.split(",");
    var mime = arr[0].match(/:(.*?);/)[1];
    const res = await fetch(dataUrl);
    const blob = await res.blob();
    return new File([blob], fileName, { type: mime });
  }

  const onUploadFile = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      const reader = new FileReader();
      var img = new Image();

      reader.onload = function (event) {
        // file is loaded

        img.onload = function () {
          console.log(img.width, img.height);
          setFileDimension({
            height: img.height,
            width: img.width,
          });
        };

        img.src = reader.result;
      };

      // console.log("image height abd stuffs", event.target.files);
      reader.addEventListener("load", (event) => {
        const image = reader.result;

        if (img.height == 345 && img.width == 345) {
          const fileData = dataUrlToFile(image, "croppedImage").then(function (
            file
          ) {
            setImageFile(file);
          });
          setIsImageSelected(true);
          setCroppedImage(image);
          setFileError(false);
          setImageToCrop(image);
        } else if (img.height < 345 || img.width < 345) {
          console.log("inin here");
          event.target.value = null;
          setFileError(true);
          setIsImageSelected(false);
          setCroppedImage(undefined);
          setImageToCrop(undefined);
        } else {
          setFileError(false);
          setCroppedImage(undefined);
          setImageToCrop(image);
        }
      });

      reader.readAsDataURL(event.target.files[0]);
    }
  };

  // const onUploadFileP1 = (event) => {
  //   if (event.target.files && event.target.files.length > 0) {
  //     const reader = new FileReader();
  //     var img = new Image();

  //     reader.onload = function (event) {
  //       // file is loaded

  //       img.onload = function () {
  //         console.log(img.width, img.height);
  //         setFileDimensionP1({
  //           height: img.height,
  //           width: img.width,
  //         });
  //       };

  //       img.src = reader.result;
  //     };

  //     // console.log("image height abd stuffs", event.target.files);
  //     reader.addEventListener("load", (event) => {
  //       const image = reader.result;

  //       if (img.height == 360 && img.width == 750) {
  //         const fileData = dataUrlToFile(image, "croppedImage").then(function (
  //           file
  //         ) {
  //           setImageFileP1(file);
  //           const imageUpdateArr = [...productImagesArray];
  //           imageUpdateArr[0] = file;
  //           setProductImagesArray(imageUpdateArr);
  //         });
  //         setIsImageSelectedP1(true);
  //         setCroppedImageP1(image);
  //         setFileErrorP1(false);
  //         setImageToCropP1(image);
  //       } else if (img.height < 360 || img.width < 750) {
  //         console.log("inin here");
  //         event.target.value = null;
  //         setFileErrorP1(true);
  //         setIsImageSelectedP1(false);
  //         setCroppedImageP1(undefined);
  //         setImageToCropP1(undefined);
  //       } else {
  //         setFileErrorP1(false);
  //         setCroppedImageP1(undefined);
  //         setImageToCropP1(image);
  //       }
  //     });

  //     reader.readAsDataURL(event.target.files[0]);
  //   }
  // };

  // const onUploadFileP2 = (event) => {
  //   if (event.target.files && event.target.files.length > 0) {
  //     const reader = new FileReader();
  //     var img = new Image();

  //     reader.onload = function (event) {
  //       // file is loaded

  //       img.onload = function () {
  //         console.log(img.width, img.height);
  //         setFileDimensionP2({
  //           height: img.height,
  //           width: img.width,
  //         });
  //       };

  //       img.src = reader.result;
  //     };

  //     // console.log("image height abd stuffs", event.target.files);
  //     reader.addEventListener("load", (event) => {
  //       const image = reader.result;

  //       if (img.height == 360 && img.width == 750) {
  //         const fileData = dataUrlToFile(image, "croppedImage").then(function (
  //           file
  //         ) {
  //           setImageFileP2(file);
  //           const imageUpdateArr = [...productImagesArray];
  //           imageUpdateArr[1] = file;
  //           setProductImagesArray(imageUpdateArr);
  //         });
  //         setIsImageSelectedP2(true);
  //         setCroppedImageP2(image);
  //         setFileErrorP2(false);
  //         setImageToCropP2(image);
  //       } else if (img.height < 360 || img.width < 750) {
  //         console.log("inin here");
  //         event.target.value = null;
  //         setFileErrorP2(true);
  //         setIsImageSelectedP2(false);
  //         setCroppedImageP2(undefined);
  //         setImageToCropP2(undefined);
  //       } else {
  //         setFileErrorP2(false);
  //         setCroppedImageP2(undefined);
  //         setImageToCropP2(image);
  //       }
  //     });

  //     reader.readAsDataURL(event.target.files[0]);
  //   }
  // };

  // const onUploadFileP3 = (event) => {
  //   if (event.target.files && event.target.files.length > 0) {
  //     const reader = new FileReader();
  //     var img = new Image();

  //     reader.onload = function (event) {
  //       // file is loaded

  //       img.onload = function () {
  //         console.log(img.width, img.height);
  //         setFileDimensionP3({
  //           height: img.height,
  //           width: img.width,
  //         });
  //       };

  //       img.src = reader.result;
  //     };

  //     // console.log("image height abd stuffs", event.target.files);
  //     reader.addEventListener("load", (event) => {
  //       const image = reader.result;

  //       if (img.height == 360 && img.width == 750) {
  //         const fileData = dataUrlToFile(image, "croppedImage").then(function (
  //           file
  //         ) {
  //           setImageFileP3(file);
  //           const imageUpdateArr = [...productImagesArray];
  //           imageUpdateArr[2] = file;
  //           setProductImagesArray(imageUpdateArr);
  //         });
  //         setIsImageSelectedP3(true);
  //         setCroppedImageP3(image);
  //         setFileErrorP3(false);
  //         setImageToCropP3(image);
  //       } else if (img.height < 360 || img.width < 750) {
  //         console.log("inin here");
  //         event.target.value = null;
  //         setFileErrorP3(true);
  //         setIsImageSelectedP3(false);
  //         setCroppedImageP3(undefined);
  //         setImageToCropP3(undefined);
  //       } else {
  //         setFileErrorP3(false);
  //         setCroppedImageP3(undefined);
  //         setImageToCropP3(image);
  //       }
  //     });

  //     reader.readAsDataURL(event.target.files[0]);
  //   }
  // };

  const changeBannerStatus = () => {
    setBannerStatus(!bannerStatus);
  };

  useEffect(() => {
    const formSetting = JSON.parse(localStorage.getItem("__state"));
    setFormSettings(formSetting.proof_of_payment_form);
  }, []);

  // console.log('business id offfffffff', businessId);

  return formSettings ? (
    <Create title="Product Images" {...props}>
      {/* <SimpleForm redirect="list"> */}
      <div className={`proof-of-payment-form-page`}>
        <div className="pop-order-number-input">
          <label>
            <span>{translate('resources.clickit_products.fields.product_name')}</span>
          </label>

          <div className="select-retailer">
            <input
              type="text"
              placeholder=""
              className="banner-position"
              value={productName}
              onChange={changeProductName}
            />
          </div>
        </div>

        {/* <div className="pop-order-number-input">
          <label>
            <span>Product Description</span>
          </label>

          <div className="select-retailer">
            <textarea
              className="inapp-notification-description"
              name="description"
              maxLength="340"
              value={productDescription}
              onChange={changeProductDescription}
            />
          </div>
        </div> */}

        <div className="pop-order-number-input">
          <label>
            <span>{translate('resources.clickit_products.fields.banner_img')} </span>
          </label>
          <input type="file" accept="image/*" onChange={onUploadFile} />
          {fileError && (
            <div className="valid-file-upload-error">
              <p>
              {translate('resources.clickit_products.fields.banner_select')}
              </p>
            </div>
          )}
          <div className="valid-file-upload">
            <p> {translate('resources.clickit_products.fields.instruction')}</p>
            <ul>
              <li>
              {translate('resources.clickit_products.fields.allowed_type')}
              </li>
              <li>{translate('resources.clickit_products.fields.max_size')}</li>
              <li>
              {translate('resources.clickit_products.fields.pixel')}
              </li>
            </ul>
          </div>
          {(fileDimension.width > 345 || fileDimension.height > 345) && (
            <div>
              <ImageCropper
                imageToCrop={imageToCrop}
                onImageCropped={(croppedImage) => {
                  setCroppedImage(croppedImage[0]);
                  const newImage = new File(
                    [croppedImage[1]],
                    croppedImage[1].name,
                    { type: croppedImage[1].type }
                  );
                  setImageFile(newImage);
                  setIsImageSelected(true);
                  console.log("---------------", newImage);

                  //convert to base64
                  // var reader = new FileReader();
                  // let imageFile = "";
                  // reader.readAsDataURL(croppedImage[1]);
                  // reader.onloadend = function () {
                  //   setImageFile(reader.result);
                  //   console.log("Base64 String - ", imageFile);
                  // };
                }}
              />
            </div>
          )}
          {(croppedImage ||
            (fileDimension.width == 345 && fileDimension.height == 345)) && (
            <div>
              <p className="cropped-image-heading">{translate('resources.clickit_products.fields.cropped_img')}</p>
              <img alt="Cropped Img" src={croppedImage} />
            </div>
          )}
        </div>

        {/* <div className="pop-order-number-input">
          <label>
            <span>Product Image One</span>
          </label>
          <input type="file" accept="image/*" onChange={onUploadFileP1} />
          {fileErrorP1 && (
            <div className="valid-file-upload-error">
              <p>
                Please select image with dimensions as 750 pixels in width & 360
                pixels in height
              </p>
            </div>
          )}
          <div className="valid-file-upload">
            <p>Instructions :</p>
            <ul>
              <li>
                Allowed file types: Images: JPG Image, JPEG Image, PNG Image
              </li>
              <li>Max file size (total): 1 MB</li>
              <li>
                Image dimensions: 750 pixels in width & 360 pixels in height
              </li>
            </ul>
          </div>
          {(fileDimensionP1.width > 750 || fileDimensionP1.height > 360) && (
            <div>
              <ImageCropper
                imageToCrop={imageToCropP1}
                onImageCropped={(croppedImage) => {
                  setCroppedImageP1(croppedImage[0]);
                  const newImage = new File(
                    [croppedImage[1]],
                    croppedImage[1].name,
                    { type: croppedImage[1].type }
                  );
                  setImageFileP1(newImage);
                  const imageUpdateArr = [...productImagesArray];
                  imageUpdateArr[0] = newImage;
                  setProductImagesArray(imageUpdateArr);
                  setIsImageSelectedP1(true);
                  console.log("---------------", newImage);
                }}
              />
            </div>
          )}
          {(croppedImageP1 ||
            (fileDimensionP1.width == 750 &&
              fileDimensionP1.height == 360)) && (
            <div>
              <p className="cropped-image-heading">Cropped Image</p>
              <img alt="Cropped Img" src={croppedImageP1} />
            </div>
          )}
        </div> */}

        {/* <div className="pop-order-number-input">
          <label>
            <span>Product Image Two</span>
          </label>
          <input type="file" accept="image/*" onChange={onUploadFileP2} />
          {fileErrorP2 && (
            <div className="valid-file-upload-error">
              <p>
                Please select image with dimensions as 750 pixels in width & 360
                pixels in height
              </p>
            </div>
          )}
          <div className="valid-file-upload">
            <p>Instructions :</p>
            <ul>
              <li>
                Allowed file types: Images: JPG Image, JPEG Image, PNG Image
              </li>
              <li>Max file size (total): 1 MB</li>
              <li>
                Image dimensions: 750 pixels in width & 360 pixels in height
              </li>
            </ul>
          </div>
          {(fileDimensionP2.width > 750 || fileDimensionP2.height > 360) && (
            <div>
              <ImageCropper
                imageToCrop={imageToCropP2}
                onImageCropped={(croppedImage) => {
                  setCroppedImageP2(croppedImage[0]);
                  const newImage = new File(
                    [croppedImage[1]],
                    croppedImage[1].name,
                    { type: croppedImage[1].type }
                  );
                  setImageFileP2(newImage);
                  const imageUpdateArr = [...productImagesArray];
                  imageUpdateArr[1] = newImage;
                  setProductImagesArray(imageUpdateArr);
                  setIsImageSelectedP2(true);
                  console.log("---------------", newImage);
                }}
              />
            </div>
          )}
          {(croppedImageP2 ||
            (fileDimensionP2.width == 750 &&
              fileDimensionP2.height == 360)) && (
            <div>
              <p className="cropped-image-heading">Cropped Image</p>
              <img alt="Cropped Img" src={croppedImageP2} />
            </div>
          )}
        </div> */}

        {/* <div className="pop-order-number-input">
          <label>
            <span>Product Image Three</span>
          </label>
          <input type="file" accept="image/*" onChange={onUploadFileP3} />
          {fileErrorP3 && (
            <div className="valid-file-upload-error">
              <p>
                Please select image with dimensions as 750 pixels in width & 360
                pixels in height
              </p>
            </div>
          )}
          <div className="valid-file-upload">
            <p>Instructions :</p>
            <ul>
              <li>
                Allowed file types: Images: JPG Image, JPEG Image, PNG Image
              </li>
              <li>Max file size (total): 1 MB</li>
              <li>
                Image dimensions: 750 pixels in width & 360 pixels in height
              </li>
            </ul>
          </div>
          {(fileDimensionP3.width > 750 || fileDimensionP3.height > 360) && (
            <div>
              <ImageCropper
                imageToCrop={imageToCropP3}
                onImageCropped={(croppedImage) => {
                  setCroppedImageP3(croppedImage[0]);
                  const newImage = new File(
                    [croppedImage[1]],
                    croppedImage[1].name,
                    { type: croppedImage[1].type }
                  );
                  setImageFileP3(newImage);
                  const imageUpdateArr = [...productImagesArray];
                  imageUpdateArr[2] = newImage;
                  setProductImagesArray(imageUpdateArr);
                  setIsImageSelectedP3(true);
                  console.log("---------------", newImage);
                }}
              />
            </div>
          )}
          {(croppedImageP3 ||
            (fileDimensionP3.width == 750 &&
              fileDimensionP3.height == 360)) && (
            <div>
              <p className="cropped-image-heading">Cropped Image</p>
              <img alt="Cropped Img" src={croppedImageP3} />
            </div>
          )}
        </div> */}

        <div className="so-save-button">
          <button
            onClick={sumbitForm}
            disabled={!isImageSelected || productNameError || onSaveDisabled}
          >
            <span>{translate('resources.clickit_products.fields.save')}</span>
          </button>
        </div>
        {showSnackbar && <Snackbar message="Element Created" />}
      </div>
      {/* </SimpleForm> */}
    </Create>
  ) : (
    <div>{translate('resources.clickit_products.fields.loading')}</div>
  );
};

export default ProductImagesCreate;
